module.exports = __webpack_public_path__ + "fonts/8fa9ef8a-e824-4c25-a2ae-90b58c98c789.abe5a43e.ttf";